import { useState } from "react";
import styles from "./styles.module.scss";

interface Props {
  details: string;
}

// Collapsible "Show details" section for error notifications that reveals the raw
// server response with a copy-to-clipboard button.
const NotificationDetails = ({ details }: Props) => {
  const [open, setOpen] = useState(false);
  const [copied, setCopied] = useState(false);

  const copy = async (e: React.MouseEvent) => {
    e.stopPropagation();
    try {
      await navigator.clipboard.writeText(details);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      // clipboard may be unavailable (insecure context) - ignore
    }
  };

  return (
    <div className={styles.details}>
      <button type="button" className={styles.toggle} onClick={() => setOpen((o) => !o)}>
        {open ? "▾ Hide details" : "▸ Show details"}
      </button>
      {open && (
        <div className={styles.body}>
          <button type="button" className={styles.copy} onClick={copy}>
            {copied ? "Copied" : "Copy"}
          </button>
          <pre className={styles.pre}>{details}</pre>
        </div>
      )}
    </div>
  );
};

export default NotificationDetails;
